import React from "react";
import MuiTypography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/system";

interface CustomTypographyProps {
    children: React.ReactNode;
    variant?:
        | "h1"
        | "h2"
        | "h3"
        | "h4"
        | "h5"
        | "h6"
        | "subtitle1"
        | "subtitle2"
        | "body1"
        | "body2"
        | "caption"
        | "button"
        | "overline";
    align?: "inherit" | "left" | "center" | "right" | "justify";
    color?: string;
    gutterBottom?: boolean;
    noWrap?: boolean;
    onClick?: () => void;
    paragraph?: boolean;
    sx?: SxProps<Theme>;
    className?: string;
}

const Typography: React.FC<CustomTypographyProps> = ({
    children,
    variant = "body1",
    align = "inherit",
    color,
    gutterBottom = false,
    noWrap = false,
    onClick,
    paragraph = false,
    sx,
    className,
}) => {
    return (
        <MuiTypography
            variant={variant}
            align={align}
            color={color}
            gutterBottom={gutterBottom}
            noWrap={noWrap}
            paragraph={paragraph}
            onClick={onClick}
            sx={sx}
            className={className}
        >
            {children}
        </MuiTypography>
    );
};

export default Typography;
